import { render, staticRenderFns } from "./UserCardInfo.vue?vue&type=template&id=0c333e20&"
import script from "./UserCardInfo.vue?vue&type=script&lang=js&"
export * from "./UserCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./user-card-info.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports